import { render } from "./gauge.vue?vue&type=template&id=0c2d61f6&lang=pug"
import script from "./gauge.vue?vue&type=script&lang=js"
export * from "./gauge.vue?vue&type=script&lang=js"

import "./gauge.vue?vue&type=style&index=0&id=0c2d61f6&lang=less"

import exportComponent from "/home/runner/work/argos-control-web/argos-control-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__